import ReactGA from 'react-ga'

const GA_TRACKING_ID = 'UA-130791799-2'

export const USER_EVENTS = {
  CONTEXTMENU: {
    MERGE: 'Merge Orders',
    COMBINE: 'Combine Orders',
    SPLIT: 'Split Orders',
    SEPARATE: 'Separate Orders',
    ADD_FOLLOW_UP: 'Add Follow Up Order',
    ADD_PARALLEL: 'Add Parallel Order',
    CREATE_BARGE_VISITS: 'Create Barge Visits for External',
    COPY: 'Copy Order'
  },
  TERMINAL_SWITCH: 'Switched Terminals'
}

export function initializeAnalyticsTracking(userName) {
  ReactGA.initialize(GA_TRACKING_ID, {
    gaOptions: {
      userId: userName
    }
  })
}

export function reportUserEvent(actionName) {
  ReactGA.event({
    category: 'User',
    action: actionName
  })
}

export function reportPageView(pageUrl) {
  ReactGA.pageview(pageUrl)
}
